import React, { useState } from 'react';
import { Info } from '../../../../../static/icons/info';
import { Typography } from '../../../atoms/typography/Typography';
import { cnMerge } from '../../../../utils/utils';

const InfoPopup = ({ description, displayDirection, className }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative">
      <button
        onBlur={() => setIsOpen(false)}
        type="button"
        aria-label="info"
        className="global-hover"
        onClick={() => setIsOpen(!isOpen)}
      >
        <Info />
      </button>
      {isOpen && (
        <div
          className={cnMerge(
            className,
            `max-md:min-w-[80vw] min-w-[30vw] z-50 bg-white border border-gray-200 p-2 sm:p-5 rounded-2xl shadow-lg absolute top-6 ${displayDirection === 'right' ? 'left-0' : 'right-0'}`
          )}
        >
          <Typography fontVariant="md" textAlign="left" className="px-2">
            {description}
          </Typography>
        </div>
      )}
    </div>
  );
};

export default InfoPopup;
